import React from 'react';
import { RenderIf } from '../RenderIf';
import './reversed-embossment.styles.scss';

export default function ReversedEmbossment({ isReversed }) {
  return (
    <RenderIf condition={isReversed}>
      <div className="reversed-emboss-container">
        <h1 className="text-danger reversed-emboss">REVERSED</h1>
      </div>
    </RenderIf>
  );
}
